function newSelectorsCreatorSlotData(id, relationship) {
  return {
    id: id,
    relationship: relationship || '',
    tag: "any",
    filters: [
      newSelectorsCreatorFilter("0", 'text'),
    ]
  };
}

function newSelectorsCreatorFilter(id, type) {
  return {
    id: id,
    type: type || 'attribute',
    attribute: {
      name: "data-testid",
      value: "example",
      operator: "is",
    },
    text: {
      value: "Example",
    }
  };
}

//init with just one slot
var selectorsCreatorSlots = [
  newSelectorsCreatorSlotData('0'),
];
bindSelectorsCreatorSlot(selectorsCreatorSlots[0]);


function bindSelectorsCreatorSlot(slotData) {
  State.set('slot-'+slotData.id+'__tag', slotData.tag);
  State.set('slot-'+slotData.id+'__relationship', slotData.relationship);
  //TODO filters for each
  $.each(slotData.filters, function(index, value) {
    bindSelectorsCreatorFilter(slotData.id, value);
  });

  State.onChange('slot-'+slotData.id+'__tag', function(value) {
    slotData.tag = value;
    getSelectorFromAllSlots();
  });

  State.onChange('slot-'+slotData.id+'__relationship', function(value) {
    slotData.relationship = value;
    getSelectorFromAllSlots();
  });
}

function bindSelectorsCreatorFilter(slotId, filterData) {
  State.set('slot-'+slotId+'__filter-'+filterData.id+'__type', filterData.type);
  State.set('slot-'+slotId+'__filter-'+filterData.id+'__text__value', filterData.text.value);
  State.set('slot-'+slotId+'__filter-'+filterData.id+'__attribute__name', filterData.attribute.name);
  State.set('slot-'+slotId+'__filter-'+filterData.id+'__attribute__value', filterData.attribute.value);
  State.set('slot-'+slotId+'__filter-'+filterData.id+'__attribute__operator', filterData.attribute.operator);
  
  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__type', function(value) {
    var thisFilter = $('[js-selectors-creator-slot="'+slotId+'"').find('[js-selectors-creator-filter-row="'+filterData.id+'"]');
    thisFilter.find('[js-selectors-creator-field-for-attr]').isShownWhen(value === 'attribute');
    thisFilter.find('[js-selectors-creator-field-for-text]').isShownWhen(value === 'text');
  });

  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__type', function(value) {
    filterData.type = value;
    getSelectorFromAllSlots();
    delay(250, function() {
      if ($(window).width() > 1023) { //on mobile devices autofocus doesn't work well
        if (value === 'attribute') {
          $('[simply-text-input="slot-'+slotId+'__filter-'+filterData.id+'__attribute__name"]').focus().select();
        } else if (value === 'text') {
          $('[simply-text-input="slot-'+slotId+'__filter-'+filterData.id+'__text__value"]').focus().select();
        }
      }
    });
  });
  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__text__value', function(value) {
    filterData.text.value = value;
    getSelectorFromAllSlots();
  });
  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__attribute__name', function(value) {
    filterData.attribute.name = value;
    getSelectorFromAllSlots();
  });
  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__attribute__value', function(value) {
    filterData.attribute.value = value;
    getSelectorFromAllSlots();
  });
  State.onChange('slot-'+slotId+'__filter-'+filterData.id+'__attribute__operator', function(value) {
    filterData.attribute.operator = value;
    getSelectorFromAllSlots();
    delay(250, function() {
      if ($(window).width() > 1023) { //on mobile devices autofocus doesn't work well
        $('[simply-text-input="slot-'+slotId+'__filter-'+filterData.id+'__attribute__value"]').focus().select();
      }
    });
  });

  State.retriggerOnParamChange('slot-'+slotId+'__filter-'+filterData.id+'__type');
  //State.retriggerOnParamChange('slot-'+slotId+'__filter-'+filterData.id+'__attribute__operator');
}

function addAnotherSelectorsCreatorSlot() {
  //add new slot to array with new random id
  var newSlotData = newSelectorsCreatorSlotData(newId(6), 'ancestor');
  selectorsCreatorSlots.push(newSlotData);
  //append new template in HTML by duplicating the last
  //update attributes in the HTML to match the new id
  var clone = $('[js-selectors-creator-slot-template]').clone();
  //get the template and clean it up
  clone.removeAttr('js-selectors-creator-slot-template');
  var templateHtml = clone.html();
  var newHtml = templateHtml.replaceAll('simply-binded', '').replaceAll('simply-binded=""', '');
  newHtml = newHtml.replaceAll('tooltipstered', '').replaceAll('tooltipstered=""', '');
  //update the template with new IDs of slots
  newHtml = newHtml.replaceAll('slot-1', 'slot-'+newSlotData.id);
  clone.html(newHtml);
  clone.attr('js-selectors-creator-slot', newSlotData.id);
  console.log(newSlotData);
  clone.appendTo('[js-selectors-slots-list]');
  clone.removeClass('is-hidden');
  //bind this new slot to state //reattach bindings & tooltips
  initSimplyTooltipster(clone);
  bindSimplySelectDropdownsToStateBasedOnItsAttributes();
  bindSimplyTextInputFieldsToStateBasedOnItsAttributes();
  bindSelectorsCreatorSlot(newSlotData);
  getSelectorFromAllSlots();
}

function removeSelectorsCreatorSlot(slotId) {
  //find by id and remove from array
  selectorsCreatorSlots = selectorsCreatorSlots.filter(item => item.id !== slotId);
  console.log(selectorsCreatorSlots);
  //find by id and remove from DOM
  $('[js-selectors-creator-slot="'+slotId+'"]').remove();
  getSelectorFromAllSlots();
}

function addAnotherSelectorsCreatorFilter(slotId) {
  //add new filter to array with random id
  var newFilter = newSelectorsCreatorFilter(newId(6));

  selectorsCreatorSlots.find(x => x.id === slotId).filters.push(newFilter);
  console.log(selectorsCreatorSlots);
  
  //append new template in HTML by duplicating from template
  var clone = $('[js-selectors-creator-slot-template]').find('[js-selectors-creator-filter-row]').clone();
  var thisSlot = $('[js-selectors-creator-slot="'+slotId+'"]');
  //TODO clean up template and add its IDs
  var templateHtml = clone.html();
  var newHtml = templateHtml.replaceAll('simply-binded', '').replaceAll('simply-binded=""', '');
  newHtml = newHtml.replaceAll('tooltipstered', '').replaceAll('tooltipstered=""', '');
  //update the template with new IDs of slots
  newHtml = newHtml.replaceAll('slot-1', 'slot-'+slotId);
  //update the template with new IDs of filters
  newHtml = newHtml.replaceAll('filter-0', 'filter-'+newFilter.id);
  clone.html(newHtml);
  clone.attr('js-selectors-creator-filter-row', newFilter.id);
  thisSlot.find('[js-selectors-creator-filter-rows]').append(clone);
  //TODO bind the new filter to state
  initSimplyTooltipster(clone);
  bindSimplySelectDropdownsToStateBasedOnItsAttributes();
  bindSimplyTextInputFieldsToStateBasedOnItsAttributes();
  bindSelectorsCreatorFilter(slotId, newFilter);
  getSelectorFromAllSlots();
}

function removeSelectorsCreatorFilter(slotId, filterId) {
  //find by id and remove from array
  slot = selectorsCreatorSlots.find(x => x.id === slotId);
  slot.filters = slot.filters.filter(item => item.id !== filterId);
  console.log(selectorsCreatorSlots);
  //find by id and remove from DOM
  $('[js-selectors-creator-slot="'+slotId+'"]').find('[js-selectors-creator-filter-row="'+filterId+'"]').remove();
  getSelectorFromAllSlots();
}

$.On('click', '[js-add-another-filter-in-slot]', function() {
  var slotId = $(this).closest('[js-selectors-creator-slot]').attr('js-selectors-creator-slot');
  addAnotherSelectorsCreatorFilter(slotId);
});

$.On('click', '[js-selectors-creator-add-more-slots]', function() {
  addAnotherSelectorsCreatorSlot();
});

$.On('click', '[js-selectors-creator-remove-slot]', function() {
  var thisSlot = $(this).closest('[js-selectors-creator-slot]');
  var thisSlotId = thisSlot.attr('js-selectors-creator-slot');
  removeSelectorsCreatorSlot(thisSlotId);
});

$.On('click', '[js-selectors-creator-remove-filter]', function() {
  var thisFilter = $(this).closest('[js-selectors-creator-filter-row]');
  var thisFilterId = thisFilter.attr('js-selectors-creator-filter-row');
  var thisSlot = $(this).closest('[js-selectors-creator-slot]');
  var thisSlotId = thisSlot.attr('js-selectors-creator-slot');
  removeSelectorsCreatorFilter(thisSlotId, thisFilterId);
});

$.On('click', '[js-copy-selector-result-to-clipboard]', function() {
  var textToCopy = $('[js-selector-result-text]').text();
  var thisButton = $(this);
  navigator.clipboard.writeText(textToCopy).then(
    function() {
      /* clipboard successfully set */
      //TODO copying success message
      //window.alert('Copied '+textToCopy); 
      thisButton.addClass('is-with-success');
      thisButton.find('[js-bem-button-hide-when-success-flashing]').isHidden();
      thisButton.find('[js-bem-button-success-inner]').isShown();
      delay(1500, function() {
        thisButton.removeClass('is-with-success');
        thisButton.find('[js-bem-button-hide-when-success-flashing]').isShown();
        thisButton.find('[js-bem-button-success-inner]').isHidden();
      });
    }, 
    function() {
      /* clipboard write failed */
      window.alert('Opps! Your browser does not support copying to clipboard via "Clipboard API"');
    }
  );
});

function getSelectorFromAllSlots() {
  //WIP

  var result = [];

  $.each(selectorsCreatorSlots, function(index, value) {
    if (index === 0) {
      result.push("//");
    } else {
      result.push('/');
    }

    if (isNotEmpty(value.relationship)) {
      result.push(value.relationship+"::");
    }

    if (value.tag === "any") {
      result.push('*');
    } else {
      result.push(value.tag);
    }

    if (value.filters.length > 0) {


      $.each(value.filters, function(filterIndex, filterValue) {
        
        result.push("[");
        
        if (filterValue.type === 'text') {
          result.push('contains(text(), "');
          result.push(filterValue.text.value);
          result.push('")');
        }

        if (filterValue.type === 'attribute') {
          if (filterValue.attribute.operator === 'is') {
            result.push('@');
            result.push(filterValue.attribute.name);
            result.push('="');
            result.push(filterValue.attribute.value);
            result.push('"');
          }
          if (filterValue.attribute.operator === 'contains') {
            result.push('contains(@');
            result.push(filterValue.attribute.name);
            result.push(' ,"');
            result.push(filterValue.attribute.value);
            result.push('")');
          }
        } 

        result.push("]");

      });

    }

  });

  $('[js-selector-result-text]').text(result.join(''));

  return result.join('');
}
